import { Check } from "lucide-react";

const checks = [
  "What is exposed?",
  "What has been remediated?",
  "Which controls are working?",
  "What evidence exists?",
  "What can be defended under review?",
];

export default function ArqReadinessAnswers() {
  return (
    <section id="readiness-answers" className="bg-arq-surface1 py-20 md:py-[120px] px-6">
      <div className="max-w-[1100px] mx-auto">
        <div className="max-w-[820px] mb-12">
          <div className="arq-label mb-6">What We Help You Answer</div>
          <h2
            className="font-display font-semibold text-arq-text mb-5"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}
          >
            Can You <span className="text-arq-blue">Prove This AI Is Secure</span> Enough to Defend?
          </h2>
          <p className="text-arq-muted text-[17px] leading-[1.75]">
            ArqeraAI gives leadership an evidence-backed answer across the controls that determine
            real business risk.
          </p>
        </div>

        <div className="arq-card p-8 md:p-10 mb-8">
          <ul className="space-y-4">
            {checks.map((c) => (
              <li key={c} className="flex items-start gap-3 text-[16px] text-arq-text/90 leading-snug">
                <Check className="w-4 h-4 mt-1.5 flex-shrink-0 text-arq-teal" aria-hidden />
                <span>{c}</span>
              </li>
            ))}
          </ul>
        </div>

        <p className="max-w-[820px] text-arq-text/95 text-[17px] font-medium">
          The outcome is evidence-backed confidence, not another report.
        </p>
      </div>
    </section>
  );
}
